export type SiteBriefSummaryBlock =
  | { kind: 'heading' | 'paragraph'; text: string }
  | { kind: 'list'; items: string[] };

export function parseSiteBriefSummary(summary: string): SiteBriefSummaryBlock[] {
  const blocks: SiteBriefSummaryBlock[] = [];
  let paragraph: string[] = [];
  const flushParagraph = () => {
    if (paragraph.length) {
      blocks.push({ kind: 'paragraph', text: paragraph.join('\n') });
      paragraph = [];
    }
  };

  for (const line of summary.split(/\r?\n/)) {
    const text = line.trim();
    const heading = /^#{1,3}\s+(.+)$/.exec(text);
    const bullet = /^[-*•]\s+(.+)$/.exec(text);
    if (!text || heading || bullet) flushParagraph();
    if (heading) {
      blocks.push({ kind: 'heading', text: heading[1] });
    } else if (bullet) {
      const previous = blocks[blocks.length - 1];
      if (previous?.kind === 'list') previous.items.push(bullet[1]);
      else blocks.push({ kind: 'list', items: [bullet[1]] });
    } else if (text) {
      paragraph.push(line);
    }
  }
  flushParagraph();
  return blocks;
}
